// extracted by mini-css-extract-plugin
export var maindiv = "darkMode-module--maindiv--XZV0i";
export var img = "darkMode-module--img--EBo8+";
export var outerdiv = "darkMode-module--outerdiv--G1mtS";
export var lightmode = "darkMode-module--lightmode--LVFRW";
export var darkmode = "darkMode-module--darkmode--M+3dF";